export default __webpack_public_path__ + "static/media/img11.36c94874.jpg";